import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// export const BASE_URL = "http://localhost:9000";
// export const BASE_URL = "https://tradedesk.india-itme.com/api";
// export const BASE_URL = "https://itme2026_uat.india-itme.com/api";
export const BASE_URL = "https://corporate.india-itme.com/itme2026/api";

//dev urls..............................................
// export const BASE_URL = "http://192.168.3.11:9305/api";
// export var link_BASE_URL = `http://192.168.3.11:9305/#/`;
// export const DOC_BASE_URL = "http://192.168.3.11:9305";
// export var REPORT_BASE_URL = `http://192.168.3.11:9305/doc`;
//..............................................................

//PROD & UAT urls..............................................
// export const BASE_URL = `https://${window.location.host}/api`;
// export var link_BASE_URL = `https://${window.location.host}/#/`;
// export const DOC_BASE_URL = `https://${window.location.host}`;
// export var REPORT_BASE_URL = `https://${window.location.host}/doc`;

// export const BASE_URL = `https://${window.location.host}/itme2026/api`;
export var link_BASE_URL = `https://${window.location.host}/itme2026/#/`;
export const DOC_BASE_URL = `https://${window.location.host}/itme2026`;
export var REPORT_BASE_URL = `https://${window.location.host}/itme2026/doc`;

//...............................................................



// prod url with HTTaPS.....................................................
// export var BASE_URL = `https://${window.location.host}/api`;
// prod url with HTTP only.....................................................
// export var BASE_URL = `http://${window.location.host}/api`;


// link for Download submitted undertaking for uat
export const sessionExpireMessage = "Session expired! Please login again.";
export const tokenInavlidMessage = "Token invalid";

export const fetchAuthReport = `${REPORT_BASE_URL}/report/SetParameterData`;
export const downloadReport = `${REPORT_BASE_URL}/WebForm/ItmeReportViewer.aspx`;
export const registrationReportName = `RegistrationDetails.rpt`;
export const registrationPreviewName = `RegistrationPreview.rpt`;
export const proformaInvoiceRpt = `ProformaInvoice.rpt`;
export const ReceiptRpt = `ReceiptVoucher.rpt`;
export const taxInvoiceRpt = `TaxInvoice.rpt`;

// auth
export const verifyLoginUrl = `${BASE_URL}/auth/verifyLogin`;

// dropdown list
export const fillListUrl = `${BASE_URL}/fillList/getDropdownList`;


//cms
export const getCmsContentUrl = `${BASE_URL}/cms/getCmsContent`
export const IUCmsContentUrl = `${BASE_URL}/cms/insertUpdateCMSContent`
export const IUCmsContentSectionUrl = `${BASE_URL}/cms/insertUpdateCMSContentSection`
export const IUCmsMenuUrl = `${BASE_URL}/cms/insertUpdateCMSMenu`
export const IUCmsFooterUrl = `${BASE_URL}/cms/insertUpdateCMSFooter`
export const IUCmsBannerUrl = `${BASE_URL}/cms/insertUpdateCMSBanner`
export const IUCmsSubheaderUrl = `${BASE_URL}/cms/insertUpdateCMSSubheader`
export const PublishCmsContentUrl = `${BASE_URL}/cms/publishCMSContent`
export const PublishCmsMenuUrl = `${BASE_URL}/cms/publishCMSMenu`
export const PublishCmsFooterUrl = `${BASE_URL}/cms/publishCMSFooter`
export const PublishCmsBannerUrl = `${BASE_URL}/cms/publishCMSBanner`
export const PublishCmsSubheaderUrl = `${BASE_URL}/cms/publishCMSSubheader`
export const updateCMSContentStatusUrl = `${BASE_URL}/cms/updateCMSContentStatus`
export const updateCMSGovtLogoStatusUrl = `${BASE_URL}/cms/updateCMSGovtLogoStatus`
export const deleteCMSMenuUrl = `${BASE_URL}/cms/deleteCMSMenu`
export const deleteCMSStaticFilesUrl = `${BASE_URL}/cms/deleteCMSStaticFiles`
export const insertUpdateCMSStaticUploadsUrl = `${BASE_URL}/cms/insertUpdateCMSStaticUploads`
export const insertUpdateCMSGovtLogosUrl = `${BASE_URL}/cms/insertUpdateCMSGovtLogos`

//cms
export const GET_CMS_CONTENT_ACTION_TYPE = "GET_CMS_CONTENT_ACTION_TYPE"
export const IU_CMS_CONTENT_ACTION_TYPE = "IU_CMS_CONTENT_ACTION_TYPE"
export const IU_CMS_CONTENT_SECTION_ACTION_TYPE = "IU_CMS_CONTENT_SECTION_ACTION_TYPE"
export const IU_CMS_MENU_ACTION_TYPE = "IU_CMS_MENU_ACTION_TYPE"
export const IU_CMS_FOOTER_ACTION_TYPE = "IU_CMS_FOOTER_ACTION_TYPE"
export const IU_CMS_BANNER_ACTION_TYPE = "IU_CMS_BANNER_ACTION_TYPE"
export const IU_CMS_SUBHEADER_ACTION_TYPE = "IU_CMS_SUBHEADER_ACTION_TYPE"
export const PUBLISH_CMS_CONTENT_ACTION_TYPE = "PUBLISH_CMS_CONTENT_ACTION_TYPE"
export const PUBLISH_CMS_MENU_ACTION_TYPE = "PUBLISH_CMS_MENU_ACTION_TYPE"
export const PUBLISH_CMS_FOOTER_ACTION_TYPE = "PUBLISH_CMS_FOOTER_ACTION_TYPE"
export const PUBLISH_CMS_BANNER_ACTION_TYPE = "PUBLISH_CMS_BANNER_ACTION_TYPE"
export const PUBLISH_CMS_SUBHEADER_ACTION_TYPE = "PUBLISH_CMS_SUBHEADER_ACTION_TYPE"
export const UPDATE_CMS_CONTENT_STATUS_ACTION_TYPE = "UPDATE_CMS_CONTENT_STATUS_ACTION_TYPE"
export const UPDATE_CMS_GOVT_LOGO_ACTION_TYPE = "UPDATE_CMS_GOVT_LOGO_ACTION_TYPE"
export const DELETE_CMS_MENU_ACTION_TYPE = "DELETE_CMS_MENU_ACTION_TYPE"
export const DELETE_CMS_STATIC_FILES_ACTION_TYPE = "DELETE_CMS_STATIC_FILES_ACTION_TYPE"
export const IU_CMS_STATIC_UPLOADS_ACTION_TYPE = "IU_CMS_STATIC_UPLOADS_ACTION_TYPE"
export const IU_CMS_GOVT_LOGO_ACTION_TYPE = "IU_CMS_GOVT_LOGO_ACTION_TYPE"

export const headers = {
  'Accept': 'application/json, text/plain, */*',  // It can be used to overcome cors errors
  'Content-Type': 'application/json',
}

//action type start.....................

export const FILL_LIST_ACTION_TYPE = "FILL_LIST_ACTION_TYPE";

// login
export const VERIFY_LOGIN_ACTION_TYPE = "VERIFY_LOGIN";
// export const CHANGE_PASSWORD_ACTION_TYPE = "CHANGE_PASSWORD_ACTION_TYPE";
export const UPDATE_PASSWORD_ACTION_TYPE = "UPDATE_PASSWORD_ACTION_TYPE";
export const GET_LOGIN_PASS_ACTION_TYPE = "GET_LOGIN_PASS_ACTION_TYPE";
// export const FILL_LIST_ACTION_TYPE = "FILL_LIST_ACTION_TYPE";
// // forget login password
export const FORGET_PASSWORD_ACTION_TYPE = "FORGET_PASSWORD_ACTION_TYPE";
export const FORGET_GET_OTP_ACTION_TYPE = "FORGET_GET_OTP_ACTION_TYPE";
export const FORGET_UPDATE_PASSWORD_ACTION_TYPE = "FORGET_UPDATE_PASSWORD_ACTION_TYPE";

// action ID name
export const countryActionId = "1";
export const stateActionId = "2";
export const cityActionId = "3";
export const pincodeActionId = "4";
export const industryActionId = "5";
export const businessSectorActionId = "6";
export const primaryServicesActionId = "7";
export const exportMarketsActionId = "8";
export const documentsListActionId = "9";
export const gstValidationListActionId = "10";
export const receiptVoucherTypeActionId = "11";
export const memberActionId = "12";
export const bankActionId = "13";
export const paymentModeActionId = "14";
export const receiptAccountTypeActionId = "15";
export const tradeServiceTypeActionId = "16";
export const organisationTypeActionId = "17";
export const enterpriseTypeActionId = "18";
export const moduleActionId = "19";


export const appVersion = '1.0.0';
export const buildNumber = '20220511';
export const NA = 'NA';

export const passErr = 'Please enter password'


export const toastError = (msg) => {
  toast.error(msg, {
    theme: 'colored',
    autoClose: 3000,
    hideProgressBar: true,
  })
}

export const toastSuccess = (msg) => {
  toast.success(msg, {
    theme: 'colored',
    autoClose: 1000,
    hideProgressBar: true,
  })
}

export function timeout(delay) {
  return new Promise(res => setTimeout(res, delay));
}

